import { baseUrl } from "./baseUrl";

export const invoicesBulkRoute = () => [`${baseUrl}`, "/billing-api/invoices/bulk"].join("");
export const createByPeriodRoute = () =>
  [`${baseUrl}`, "invoices-export-api", "invoices", "createByPeriod"].join("/");

export const downLoadFileRoute = (...params) =>
  [`${baseUrl}`, "/invoices-export-api/", ...params].join("");

export const createInvoiceRoute = () => [`${baseUrl}`, "billing-api", "invoices"].join("/");
